import React, { useEffect, useState } from 'react';
import DineshTest from '../../asset/DineshTest.jpg'
import GugaPriya from '../../asset/GugaPriya.jpg'
import Karthik from '../../asset/Karthik.jpg'
import Arun from '../../asset/Arun.jpg'

const Card = ({ children, className, style }) => (
  <div className={className} style={style}>{children}</div>
);

const CardContent = ({ children, className }) => (
  <div className={className}>{children}</div>
);

const Testimonial = ({ name, position, testimonial, avatar }) => (
  <Card
    className="border-2 shadow-sm h-full bg-[#FFF8E9] border-[#FFDAA3] transition-all duration-300"
    style={{ borderRadius: "25px" }}
  >
    <CardContent className="pt-4 sm:pt-6 px-4 sm:px-6 pb-6 sm:pb-8 h-full">
      <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
        <img
          src={avatar}
          alt={name}
          className="w-12 h-12 sm:w-16 sm:h-16 rounded-full object-cover"
        />
        <div>
          <h4 className="text-[#334047] font-semibold text-base sm:text-lg">{name}</h4>
          <p className="text-[#6D7E94] text-sm">{position}</p>
          <div className="flex mt-1 sm:mt-2">
            {[...Array(5)].map((_, i) => (
              <svg key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-[#FE7443]" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            ))}
          </div>
        </div>
      </div>
      <p className="text-[#0B2549] text-xs sm:text-[1rem] leading-relaxed">{testimonial}</p>
    </CardContent>
  </Card>
);

const TestimonialsSection = () => {
  const [current, setCurrent] = useState(0);

  const testimonials = [
    {
      name: "Dinesh",
      position: "Creative Head, Crux",
      testimonial: "I never thought I'd enjoy a coworking space before. Offis Bay has proved me wrong.",
      avatar: DineshTest
    },
    {
      name: "Priya, MD",
      position: "Ideassion Institute of Talent Transformation",
      testimonial: "What I really appreciate is how clean and well maintained the facility is. Paired with strong wifi & unlimited coffee, that alone is worth it!",
      avatar: GugaPriya
    },
    {
      name: "Arun M ",
      position: "SapientHR CEO",
      testimonial: "The dedicated zones for focus boost our efficiency, and the professional setting strengthened our brand image. We also appreciate the coworking community for its networking potential. Offisbay strikes the right balance of flexibility, privacy, and professionalism. ",
      avatar: Arun
    },
    {
      name: "Karthik",
      position: "Founder & CEO, Coverton Insurance",
      testimonial: "Being the CEO of an insurance broking firm, I value environments that reflect credibility.Offisbay delivers just that; a premium address, well-managed meeting spaces, and a community apt for networking. It’s an excellent workspace for client-facing businesses like ours.",
      avatar: Karthik
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <section className="py-8 sm:py-16 px-4 sm:px-6 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-[#966376] font-sans text-lg sm:text-2xl font-semibold text-center">TESTIMONIALS</h2>
        <h3 className="text-[#0B2549] font-regrade text-2xl sm:text-3xl md:text-5xl font-bold leading-tight mt-3 text-center">
          Hear From Our Members
        </h3>
        <p className="text-[#6D7E94] font-[500] text-center mt-2 mb-8 sm:mb-16">
          They're satisfied with Offis Bay!
        </p>

        <div className="flex justify-center items-center gap-4 h-[370px] relative transition-all">
          {testimonials.map((testimonial, index) => {
            const position =
              index === current
                ? "center"
                : index === (current - 1 + testimonials.length) % testimonials.length
                ? "left"
                : index === (current + 1) % testimonials.length
                ? "right"
                : "hidden";

                let classNames = "transition-all duration-500 ease-in-out absolute";

                if (position === "center") {
                  classNames += " opacity-100 scale-100 z-20 transform translate-x-0";
                } else if (position === "left") {
                  classNames += " opacity-40 scale-90 z-10 transform -translate-x-[70%] blur-sm";
                } else if (position === "right") {
                  classNames += " opacity-40 scale-90 z-10 transform translate-x-[70%] blur-sm";
                } else {
                  classNames += " opacity-0 scale-75 z-0 pointer-events-none"; // hide everything else
                }
                

            return (
              <div key={index} className={classNames + " w-full max-w-sm"}>
                <Testimonial {...testimonial} />
              </div>
            );
          })}
        </div>

        <div className="flex justify-center items-center gap-3 mt-6">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === current ? "bg-[#966376] scale-[1.5]" : "bg-gray-300"
              }`}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
